import { _, ts } from '_core';

import { Params } from './types';

// prepareSignalExposureVsTime
const transform = (data: ts.types.widgets.TableData, hasBenchmark: boolean) => {
  const newData = data.map((item) => {
    const newItem = {} as ts.types.widgets.TableData[number];
    Object.keys(item).forEach((key) => {
      if (!key.startsWith('benchmark') || hasBenchmark) {
        const formattedKey = key.replaceAll('=>', ':');
        newItem[formattedKey] = item[key];
      }
    });
    return newItem;
  });

  return newData;
};

const validate = (params: Params) => {
  if (_.isEmpty(params.analysis_pipelined_signals) || !_.some(params.analysis_pipelined_signals, (el) => el.signal_id))
    return ['Signals is a required field.'];
  return [];
};

export { transform };
export { validate };
